// extracted by mini-css-extract-plugin
module.exports = {"openingSelectionButton":"providers-yelp-components-OpeningsSelection-OpeningsSelection__openingSelectionButton--3RmWI"};